import { TestimonialCard } from './TestimonialCard'
import { useTranslation } from '@/hooks/useTranslation'

export function Testimonials() {
	const { t } = useTranslation()
	
	return (
		<section id="testimonials" className="fb-reviews fb-section fb-container">
			<div className="mx-auto">
				<div className="text-center mb-16">
					<h2 className="font-heading text-3xl font-semibold tracking-tight text-balance sm:text-5xl mb-4">
						{t('testimonials.title')}
					</h2>

				</div>

				{/* Métriques de performance */}


				<div className="fb-review-grid">
					<a
						href="https://www.uneed.best/tool/feedbask?tab=comments"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Hasan-Toor"
							role=""
							content="5 Star Best app to collect feedback"
							avatar="https://pbs.twimg.com/profile_images/1970850369023377408/h9B5r6Q5_400x400.jpg"
							rating={5}
						/>
					</a>

					<a
						href="https://www.uneed.best/tool/feedbask?tab=comments"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="florriandarroman"
							role=""
							content="I'm an early user. And already really happy with it! Such an easy way to get user feedback."
							avatar="https://apcdouatoejrvwoqevfc.supabase.co/storage/v1/object/public/avatars/1747321194206-FlorianDarromanPP2.jpg"
							rating={5}
						/>
					</a>

					<a
						href="https://x.com/AmandineFlachs/status/1920543849480355848"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Amandine Flachs"
							role=""
							content="I love it and immediately added feedbask to my new project! So easy to use."
							avatar="https://pbs.twimg.com/profile_images/1425082226090418184/cRJInE1f_400x400.jpg"
							rating={5}
							platform="twitter"
						/>
					</a>

					<a
						href="https://x.com/xcanchal/status/1932917542592655394"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Xavi Canchal"
							role="@xcanchal"
							content="Just replaced Crisp chat by Feedbask on Unlimitedtales. Added Crisp hoping to get user feedback but I couldn't provide sync help if needed. With Feedbask the communication is expected to be async so I'm less worried about it."
							avatar="https://unavatar.io/twitter/xcanchal"
							rating={5}
							platform="twitter"
						/>
					</a>

					<a
						href="https://subclip.app"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Samik"
							role="@prosamik"
							content="I like the email follow up feature of feedbask when some user reports a bug and on resolving it i can update in dashboard and it send automatic email to user on my behalf this way user dont have to signup on feedbask but I can still communicate"
							avatar="https://pbs.twimg.com/profile_images/1925648841908330496/U1jCPUs0_400x400.jpg"
							rating={5}
							platform="subclip"
						/>
					</a>

					<a
						href="https://feedbask.com/reviews/feedbask"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Neel Das"
							role=""
							content="I was looking for a tool like Feedbask and I am so lucky to find just that, a tool that makes it super duper easy to collect user feedback. Feedbask is really quick & easy to setup although it helps if you have a little bit of technical knowledge as you'd need to add widget code on your website. Highly recommend to saas founders to have this in their toolkit."
							avatar="https://unavatar.io/twitter/Nilzkool"
							rating={5}
							platform="feedbask"
						/>
					</a>

					<a
						href="https://x.com/VynseDev/status/1974523937322402128"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Vincent S"
							role="@VynseDev"
							content="Added @feedbask_com on my project. Updated Consistrack app with it."
							avatar="https://unavatar.io/twitter/VynseDev"
							rating={5}
							platform="twitter"
						/>
					</a>

					<a
						href="https://www.uneed.best/tool/feedbask?tab=comments"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="julien-legrand"
							role=""
							content="As a first time user, I'm very happy with the app."
							avatar=""
							rating={5}
						/>
					</a>

					<a
						href="https://twitter.com/NicolasCDev/status/1932448162196668911"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Nicolas C"
							role="@NicolasCDev"
							content="Yesterday I integrated feedbask into my latest SaaS. It's a tool for collecting user feedback and reporting bugs. Ultra simple integration, great customization, impeccable onboarding. Today I received my first feedback!"
							avatar="https://unavatar.io/twitter/NicolasCDev"
							rating={5}
							platform="twitter"
						/>
					</a>

					<a
						href="https://x.com/mq_p/status/1940061356905963837"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="Minh Pham"
							role="@mq_p"
							content="Your launch will suck anyways. So launch fast, get feedbacks and iterate quickly. That's why I added @feedbask_com"
							avatar="https://unavatar.io/twitter/mq_p"
							rating={5}
							platform="twitter"
						/>
					</a>

					<a
						href="https://www.uneed.best/tool/feedbask?tab=comments"
						target="_blank"
						rel="noopener noreferrer"
						className="fb-review-link"
					>
						<TestimonialCard
							name="find-saas-tools"
							role=""
							content="Best app to collect feedback"
							avatar=""
							rating={5}
						/>
					</a>


				</div>


			</div>
		</section>
	)
}
